import { render, staticRenderFns } from "./ActionNoti.vue?vue&type=template&id=da70f4b2&"
import script from "./ActionNoti.vue?vue&type=script&lang=js&"
export * from "./ActionNoti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports